import Axios from "axios";

const root = window.location.hostname.split(".");
console.log(root);
export const getAxiosTotall = () => {
  return Axios.create({
    baseURL: `https://api.panel.${
      root[0] === "localhost" ? "devbarest" : root[1]
    }.ir/`,
    headers: {
      "x-auth-token": localStorage.getItem("adminToken"),
    },
  });
};
export const getAxiosNotif = () => {
  return Axios.create({
    baseURL: "https://api.devbarest.ir/",
    headers: {
      "x-auth-token": localStorage.getItem("adminToken"),
    },
  });
};
